import { ClientPathSchema } from '@/features/dashboard/client/clientSchema'
import { ClientDetail } from '@/features/dashboard/client/detail/ClientDetail'
import { usePageTitle } from '@/hooks/usePageTitle'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/clients/$clientId/')({
  component: RouteComponent,
  parseParams: ClientPathSchema.parse
})

function RouteComponent() {
  usePageTitle('顧客詳細')
  return <ClientDetail />
}
